import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  createItem,
  updateItem,
  deleteById,
  getPermissionId,
} from "./roleAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permission: [],
};

export const fetchRole = createAsyncThunk("role/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const fetchPermission = createAsyncThunk(
  "role/permision",
  async (payload) => {
    const response = await getPermissionId(payload);
    return response.data;
  }
);

export const addItem = createAsyncThunk("userrole/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "role/editItem",
  async ({ params, id }) => {
    const response = await updateItem(params, id);
    return response.data;
  }
);
export const removeById = createAsyncThunk(
  "role/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permission = action.payload.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = roleSlice.actions;

export const selectRole = (state) => state.role.data;
export const selectPermission = (state) => state.role.permission;
export const selectLoading = (state) => state.role.loading;
export const selectError = (state) => state.role.error;
export const selectPageNo = (state) => state.role.pageNo;
export const selectPageSize = (state) => state.role.pageSize;
export const selectTotalRecord = (state) => state.role.totalRecord;
export const selectSelected = (state) => state.role.selected;
export const selectResult = (state) => state.role.result;

export default roleSlice.reducer;
